<div class="bg-white rounded mb-3">
  <div class="border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2">{{ 'Sellers.Products.Business' | translate }}</h3>
    </div>
  </div>
  <form [formGroup]="profileForm" enctype="multipart/form-data" *ngIf="profileForm">
    <div class="p-4">
      <div class="row">
        <div class="col-5 ml-3">
          <div class="business-logo-container">
            <img *ngIf="imageSrc" width="150" height="150" [src]="sanitizer.bypassSecurityTrustUrl(imageSrc)"
                 alt="selectedFile.name" />

            <button type="button" (click)="fileInput.click()" mat-flat-button
                    style="color: white;background-color: rgba(15, 117, 189, 1)" class="change-button">
              <mat-icon *ngIf="!selectedFile" class="business-info__icon">camera_alt</mat-icon>
              <input #fileInput type="file" (change)="onFileInput($event)" accept="image/*" style="display: none;"
                     formControlName="businessLogo" />
            </button>
            <mat-error *ngIf="emptyLogo">
              {{ 'Sellers.Products.LogoEmpty' | translate }}
            </mat-error>
          </div>
        </div>
        <div class="col-7">
          <div class="mb-3">
            <div>
              <label>{{ 'Sellers.Products.BusinessName' | translate }} <span class="text-danger">*</span></label>
              <input [readonly]="!isAdmin && isVerifed" class="form-control" type="text"
                     placeholder="{{ 'Sellers.Products.BusinessName' | translate }}"
                     formControlName="name" required />
            </div>
            <small *ngIf="formValidator.formErrors.name" class="text-danger">
              {{ formValidator.formErrors.name }}
            </small>
          </div>
          <div class="mb-3">
            <div>
              <label>{{ 'Sellers.Products.Category' | translate }} <span class="text-danger">*</span></label>
              <div>
                <select *ngIf="categoryOptions" formControlName="CategoryId" class="form-control">
                  <option disabled [value]="null">{{ 'Sellers.Products.ChooseCategory' | translate }}</option>
                  <option *ngFor="let option of categoryOptions" [value]="option.id">{{option.name}}</option>
                </select>
              </div>
            </div>
            <small *ngIf="formValidator.formErrors.CategoryId" class="text-danger">
              {{ formValidator.formErrors.CategoryId }}
            </small>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column align-items-start mb-3">
        <label>{{ 'Sellers.Products.BusinessDescription' | translate }} <span class="text-danger">*</span></label>
        <textarea class="form-control" placeholder="{{ 'Sellers.Products.BusinessDescription' | translate }}" cols="30" rows="3"
                  formControlName="description"></textarea>
        <small *ngIf="formValidator.formErrors.description" class="text-danger">
          {{ formValidator.formErrors.description }}
        </small>
      </div>
      <div class="row mb-3" >
        <div [ngClass]="{'col-lg-4':!facebookStatus,'col-12 col-md-8 col-lg-6':facebookStatus}"  class=" mb-2 d-flex flex-column align-items-start">
          <label>
            {{ 'Sellers.Products.FacebookProfileLink' | translate }} <span class="text-danger">*</span>
            <app-verify-icon iconColor="primary" verifyIconName='verified' class="icon-small" *ngIf="facebookStatus">

            </app-verify-icon>
          </label>
          <input class="form-control" type="url" formControlName="link_fb" />
          <small *ngIf="formValidator.formErrors.link_fb" class="text-danger">
            {{ formValidator.formErrors.link_fb }}
          </small>
        </div>
        <div class="col-12 col-md-4  mb-2 d-flex flex-column align-items-start" *ngIf="facebookStatus">
          <label>Facebook Likes  </label>
          <p class="mt-2" >{{facebookLikes}}</p>
        </div>
        <div [ngClass]="{'row':facebookStatus}">
          <div [ngClass]="{'col-lg-4':!facebookStatus,'col-lg-6':facebookStatus}" class="mb-2 d-flex flex-column align-items-start">
            <label>
              {{ 'Sellers.Products.TwitterProfileLink' | translate }}:
            </label>
            <input class="form-control" type="url" formControlName="link_tw" />
            <small *ngIf="formValidator.formErrors.link_tw" class="text-danger">
              {{ formValidator.formErrors.link_tw }}
            </small>
          </div>
          <div [ngClass]="{'col-lg-4':!facebookStatus,'col-lg-6':facebookStatus}" class="d-flex flex-column align-items-start">
            <label>
              {{ 'Sellers.Products.LinkedInProfileLink' | translate }}:
            </label>
            <input class="form-control" type="url" formControlName="link_li" />
            <small *ngIf="formValidator.formErrors.link_li" class="text-danger">
              {{ formValidator.formErrors.link_li }}
            </small>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div>
          <label>Referral Code<span class="text-danger">*</span></label>
          <input [readonly]="!isAdmin && isVerifed" class="form-control" type="number"
            placeholder="Referral Code"
            formControlName="referrer_code"/>
        </div>
        <small *ngIf="formValidator.formErrors.code" class="text-danger">
          {{ formValidator.formErrors.code }}
        </small>
      </div>

      <div class="row mb-3">
        <div class="col-lg-5 d-flex flex-column align-items-start">
          <label>{{ 'Sellers.Products.CustomPaymentFees' | translate }}</label>
        </div>
        <div class="col-lg-4 d-flex flex-column align-items-start">
          <mat-radio-group formControlName="customPaymentFeesOnBuyer">
            <mat-radio-button [value]="true" class="me-3">{{ 'Sellers.Products.Yes' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false">{{ 'Sellers.Products.No' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <h3 class="d-flex justify-content-center mb-2">
        {{ 'Sellers.Products.CustomerServiceContact' | translate }}
      </h3>
      <div class="row mb-3">
        <div class="col-lg-6 mb-2 d-flex flex-column align-items-start">
          <label>
            {{ 'Sellers.Products.CustomerServiceEmail' | translate }}
            <app-verify-icon iconColor="primary" verifyIconName='verified'
                             class="icon-small" *ngIf="emailStatus">
            </app-verify-icon>
          </label>
          <input class="form-control" type="email"
                 placeholder="{{ 'Sellers.Products.CustomerServiceEmail' | translate }}"
                 formControlName="cs_email" />
          <small *ngIf="formValidator.formErrors.cs_email" class="text-danger">
            {{ formValidator.formErrors.cs_email }}
          </small>
        </div>
        <div class="col-lg-6 d-flex flex-column align-items-start">
          <label>
            {{ 'Sellers.Products.CustomerServiceMobile' | translate }}
            <app-verify-icon iconColor="primary" verifyIconName='verified'
                             class="icon-small" *ngIf="phoneStatus">
            </app-verify-icon>
          </label>
          <input class="form-control" type="tel"
                 placeholder="{{ 'Sellers.Products.CustomerServiceMobile' | translate }}"
                 formControlName="cs_phone" />
          <small *ngIf="formValidator.formErrors.cs_phone" class="text-danger">
            {{ formValidator.formErrors.cs_phone }}
          </small>
        </div>
      </div>
      <app-business-details *ngIf="isAdmin"></app-business-details>
      <div class="d-flex justify-content-end">
        <button type="submit" (click)="onSubmit(profileForm.value)" class="btn btn-primary">
          {{ 'Sellers.Products.Save' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
